module.exports = __webpack_public_path__ + "img/bottom.19b96244.png";